const BASE = process.env.REACT_APP_IMAGE_BASE_URL ?? '';

export const thumbUrl = (i: number) => `${BASE}/gallery-${i}-thumb.jpg`;
export const fullUrl = (i: number) => `${BASE}/gallery-${i}.jpg`;
